import { gql } from '@apollo/client';

export const IS_VALID_EMIS = gql`
  query IsValidEmis($emisNumber: String!) {
    isValidEmis(emisNumber: $emisNumber)
  }
`;
